import React, { useEffect } from 'react';

import { logout } from '../actions/auth';

const LogoutPage = () => {
  useEffect(() => {
    logout();
  }, []);
  return null;
};

export default LogoutPage;
